import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=44021f52&"
import script from "./user-avatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./user-avatar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=44021f52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports